<template>
    <div v-if="sortedRecords.length > 0">
        <table class="table queue-table">
            <thead>
                <tr>
                    <th v-for="el in sortedHeaders">
                        {{generateLabel(el.label)}}
                    </th>
                </tr>
            </thead>
            <tbody class="customBody">
                <tr class="queue-table-row" v-for="(el, index) in sortedRecords">
                    <td v-for="key in sortedHeaders" :class="{'white-background': index % 2 === 0, 'gray-background': index % 2 !== 0}">
                        <span :class="{'total': key.key.includes('total')}">{{ el[key.key] }}</span>
                        <span v-if="(!isNaN(el[key.key]) && el[key.key]) && !key.key.includes('total')"><br/></span>
                        <span v-if="(!isNaN(el[key.key]) && el[key.key]) && !key.key.includes('total')" class="percent">{{showPercent(el, key)}}</span>
                    </td>
                </tr>
            </tbody>
            <tfoot>
                <tr id="footer-row">
                    <th v-for="el in sortedHeaders">
                        {{ sumValues(el.key) }}
                    </th>
                </tr>
            </tfoot>
        </table>
    </div>
    <div v-else id="no-records">
        <span><i class="fas fa-circle-xmark"></i>   Não há registros para exibir</span>
    </div>
</template>
  
<script>
    import ExcelJS from 'exceljs';
    import { saveAs } from 'file-saver';
  export default {
    props: ['queueMotivationData', 'period', 'phoneQueuesArray'],
    data() {
        return {
            tableRecords: [],
            tableHeader: [{key: 'queue', label: 'Fila de Atendimento'}],
            tableData: this.queueMotivationData,
            queueTotal: {}
        };
    },
    computed: {        
        sortedRecords() {
            let sorted = []; 
            sorted = this.tableRecords.sort((a, b) => {
                const somaA = this.sumRecord(a);
                const somaB = this.sumRecord(b);
                return somaB - somaA;
            });
            return sorted;
        },
        sortedHeaders(){
            return this.tableHeader
        }
    },
    methods: {
        sumValues(column) {
            if(column != 'queue'){
                let soma = 0;
                if(Object.entries(this.tableRecords).length > 0){
                    Object.values(this.tableRecords).forEach(el => {
                        soma += el[column];
                    });
                }
                return soma;
            } else {
                return 'Total'
            }
        },

        sumRecord(registro) {
            let soma = 0;
            for (const key in registro) {
                if (key.startsWith("qtd_")) {
                    soma += registro[key];
                }
            }
            return soma;
        },

        generateLabel(label){
            if(label == 'Fila de Atendimento'){
                return label;
            } else {
                if(label == 'acompanhamento'){
                    return 'Status do Processo';
                } else if(label == 'duvidas'){
                    return 'Dúvidas';
                } else if(label == 'inatividade'){
                    return 'Inatividade';
                }  else if(label == 'naoinformado'){
                    return 'Não informado';
                }  else if(label == 'outros'){
                    return 'Outros';
                } else {
                    return 'Total';
                }
            }
        },

        showPercent(el, key){
            if(!key['key'].includes('_')) return ''; 
            const keyString = key['key'].split('_');
            const pctKey = `pct_${keyString[1]}`
            return el[pctKey];
        },

        async generateExcel(data){
            if(data != 'queueMotivation') return;
            const workbook = new ExcelJS.Workbook();
            const worksheet = workbook.addWorksheet('Sheet1');

            // Adicionar cabeçalhos
            const headerRow = worksheet.addRow(this.tableHeader.map(header => this.generateLabel(header.label)));
            headerRow.font = { bold: true };
            worksheet.autoFilter = `A1:${String.fromCharCode(65 + this.tableHeader.length - 1)}1`; // Ativar filtro

            // Adicionar registros
            this.tableRecords.forEach(record => {
              const rowData = this.tableHeader.map(header => record[header.key]);
              worksheet.addRow(rowData);
            });

            const buffer = await workbook.xlsx.writeBuffer();
            const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
            saveAs(blob, 'motivacao_fila_chat.xlsx');
        },
    },
    watch: {
        queueMotivationData(){
            this.tableRecords = [];
            this.tableData = [];
            this.tableHeader = [{key: 'queue', label: 'Fila de Atendimento'}]
            const queueArray = Object.entries(this.queueMotivationData);

            queueArray.forEach(el => this.queueTotal[el[0]] = 0);

            queueArray.forEach(entry => {
                this.queueTotal[entry[0]] = entry[1]['total'];
                Object.entries(entry[1]).forEach(subject => {
                    let keynameAbs = '';
                    let keynamePct = '';
                    keynameAbs = `qtd_${subject[0]}`;
                    keynamePct = `pct_${subject[0]}`
                    if(!this.tableHeader.find(obj => obj.label == subject[0])){
                        this.tableHeader.push({key:keynameAbs, label: subject[0]})
                    }

                    const record = this.tableRecords.find(obj => obj.queue == entry[0])
                    
                    const pct = (subject[1] * 100) / this.queueTotal[entry[0]]
                    const pctString = pct.toFixed(2).toString().replaceAll('.', ',') + '%';

                    if(!record){
                        this.tableRecords.push({queue: entry[0], [keynameAbs]: subject[1], [keynamePct]: pctString}) 
                    } else {
                        record[keynameAbs] = subject[1];
                        record[keynamePct] = pctString;
                    }
                })
            })
            if(Object.entries(this.queueMotivationData).length > 0){
            } 
            this.$emit('tableLoaded', 'queueMotivationTable')
        }
    },
    mounted() {
        this.$root.$on('download', this.generateExcel)
    },
  };
</script>

<style scoped>
.queue-table {
  /* white-space: nowrap; */
  margin: 0;
  border: none;
  border-collapse: separate;
  border-spacing: 0;
  font-size: smaller;
  min-height: 400px;
}

.queue-table td,
.queue-table th {
    font-weight: bold;
    text-align: center;
    vertical-align: middle !important;
    white-space: nowrap;
}

.queue-table thead th {
    background-color: #1c869a;
    color: white;
    position: sticky;
    top: 0;
    z-index: 3;
    width: 25vw;
    border: 1px solid white;
}
.queue-table thead th:first-child {
    position: sticky;
    left: 0;
    z-index: 4;
}
.queue-table tfoot th {
    position: sticky;
    bottom: 0;
    z-index: 3;
    width: 25vw;
    background-color: #9cc0c7;
    border: 1px solid white;
    padding: 2px;
}
.queue-table tfoot th:first-child {
    position: sticky;
    left: 0;
    z-index: 4;
}
.queue-table tbody tr td:first-child { /*Coluna dos bancos*/
    font-weight: bold;
    text-align: left;
    position: sticky;
    left: 0;
    z-index: 2;
    max-width: 250px;
    white-space: normal;
}
.queue-table td {
    padding: 4px 5px;
    text-align: center;
}

.percent {
    font-size: smaller;
    font-style: italic;
}

.total {
    font-size: small;
    color: #1c869a;
}

.white-background {
    background-color: white;
}

.gray-background {
    background-color: lightgray;
}

#no-records {
    height: 90%;
    display: flex;
    justify-content: center;
}

#no-records span{
    align-self: center;
    font-size: x-large;
    font-weight: bold;
    color: #1c869a;
}

#no-records span i{
    color: red;
}

</style>